<div>
    <div class="icon-type">
        <nb-icon [icon]="'fa-' + type.Icon"></nb-icon>
    </div>
    {{ type.Code | expenseTypeName | async }}
</div>
